import PlaylistOutline from './PlaylistOutline'

export default PlaylistOutline
// eslint-disable-next-line import/export
export * from './PlaylistOutline'
